import { createSelector, createSlice } from "@reduxjs/toolkit";

import { SliceKeys } from "@sso/constant";
import { RootState } from "@sso/store";
import { queryBuilder } from "@sso/utils";

import { organisationInitialState } from "./initialState";
import { organisationReducer } from "./reducers";

export const OrganisationSlice = createSlice({
  name: SliceKeys.ORGANISATION,
  initialState: organisationInitialState,
  reducers: { ...organisationReducer },
});

export const {
  setOrganisationPageSize,
  setOrganisationPageIndex,
  setOrganisationSortColumn,
  setOrganisationSearchColumn,
  addOrganisationToMergeArray,
  clearOrganisationMergeArray,
  clearOrganisationSearchColumn,
  removeOrganisationFromMergeArray,
} = OrganisationSlice.actions;

export const selectOrganisationPagination = createSelector(
  (state: RootState) => state.organisation.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setOrganisationPageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setOrganisationPageIndex,
    },
    sort,
    search: { object: search, onChange: setOrganisationSearchColumn, onClear: clearOrganisationSearchColumn },
  }),
);
export const selectMergeOrganisations = createSelector(
  (state: RootState) => state.organisation.mergeOrgs,
  mergeOrgsArray => mergeOrgsArray,
);
export const selectOrganisationQuery = createSelector(
  (state: RootState) => state.organisation.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default OrganisationSlice.reducer;
